
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Authority, Permission } from 'ah-api-gateways';
import groupBy from 'lodash/groupBy';
import sortBy from 'lodash/sortBy';
import { cloneDeep } from 'lodash';

@Component
export default class PermissionsForm extends Vue {
  @Prop({ required: true }) authorities!: Authority[];

  @Prop({ required: true }) value!: Permission[];

  @Prop({ default: false }) hideSwitch!: boolean | string;

  @Prop({ default: false }) hideGroupTitle!: boolean | string;

  @Prop({ default: false }) readonly!: boolean | string;

  get shouldDisplaySwitch() {
    return this.hideSwitch === false;
  }

  get shouldBeReadonly() {
    return this.readonly !== false;
  }

  get shouldDisplayGroupTitle() {
    return this.hideGroupTitle === false;
  }

  getCurrentValue() {
    let out = cloneDeep(this.value);
    if (out.length === 0) {
      out = this.authorities.map((authority) => ({ authority: authority.id, allow: false }));
    }
    return out;
  }

  setPermission(id: string, value: boolean) {
    let tempVal = this.getCurrentValue();
    const permission = tempVal.find((permission) => permission.authority === id);
    if (permission) {
      permission.allow = value;
      this.$emit('permission-change', permission);
    }
    this.$emit('update:value', tempVal);
  }

  hasPermission(id: string) {
    const permission = this.value.find((permission) => permission.authority === id);
    return permission?.allow ?? false;
  }

  @Watch('authorities', { immediate: true })
  onAuthoritiesChange() {
    if (this.authorities.length && !this.value.length) {
      this.$emit('update:value', this.getCurrentValue());
    }
  }

  get groupedAuthoritites() {
    const out = groupBy(this.authorities, 'sectionName');

    return Object.keys(out)
      .map((group) => ({
        name: group,
        index: out[group][0].sectionIndex,
        authorities: sortBy(out[group], 'index'),
      }))
      .sort((a, b) => a.index - b.index);
  }
}
